var map = {
	"./Aboutus/Image_1.png": 55203,
	"./AdditionalOptionForLastConversation/01.png": 90046,
	"./AdditionalOptionForLastConversation/copy.png": 64720,
	"./AdditionalOptionForLastConversation/disLike.png": 62210,
	"./AdditionalOptionForLastConversation/edit.png": 52795,
	"./AdditionalOptionForLastConversation/like.png": 52990,
	"./AdditionalOptionForLastConversation/share.png": 26854,
	"./BlogImage/2.png": 17294,
	"./BlogImage/4.png": 27672,
	"./BlogImage/blog01.png": 78047,
	"./BlogImage/blog02.jpg": 87360,
	"./BlogImage/blog03.png": 79693,
	"./BlogImage/blog04.png": 7186,
	"./BlogImage/blog05.png": 5051,
	"./BlogImage/blog06.png": 43072,
	"./BlogImage/blog07.png": 97897,
	"./BlogImage/blog08.png": 68990,
	"./BlogImage/blog09.png": 87303,
	"./BlogImage/blog1.png": 12981,
	"./BlogImage/blogImage2.png": 96669,
	"./BlogImage/blogImage3.png": 63636,
	"./BlogPageImage/InstagramIcon.png": 49416,
	"./BlogPageImage/image1.png": 60411,
	"./BlogPageImage/image2.png": 5376,
	"./BlogPageImage/image3.png": 60201,
	"./BlogPageImage/linkdinIcon.png": 23937,
	"./BlogPageImage/logo.png": 80002,
	"./Button/Blog.png": 66721,
	"./Button/Music Library.png": 96485,
	"./Button/PDF.png": 81991,
	"./Button/Picture.png": 57631,
	"./Button/landingPage_checked_icon.png": 65771,
	"./Button/landingPage_user_icon.png.png": 16016,
	"./Button/landingPage_vector_icon.png": 23423,
	"./Button/presentation.png": 3829,
	"./Button/search.png": 72489,
	"./Button/settings.png": 90482,
	"./Button/translate.png": 68055,
	"./Button/videoIcon.png": 93899,
	"./DeleteIcon.png": 71850,
	"./DeleteIcons.png": 96267,
	"./DeleteIcons_onHover.png": 9853,
	"./FLOW.gif": 36351,
	"./File_Icon/image_icon.png": 84176,
	"./File_Icon/jpgIcon.png": 62595,
	"./File_Icon/movIcon.png": 8952,
	"./File_Icon/mp3_logo.png": 62385,
	"./File_Icon/mp4Icon.png": 82839,
	"./File_Icon/pdf_icon.png": 42955,
	"./File_Icon/pngIcon.png": 56187,
	"./File_Icon/pngIcon2.png": 53281,
	"./File_Icon/powerpoint_logo.png": 35090,
	"./File_Icon/word_logo.png": 99983,
	"./File_Icon/xlsx_icon.png": 72882,
	"./File_Icon/youtube_icon.png": 49216,
	"./FiletypeLogos.png": 60728,
	"./Flag/australia.png": 2893,
	"./Flag/canada.png": 96225,
	"./Flag/france.png": 11046,
	"./Flag/india.png": 26694,
	"./Flag/united arab emirates.png": 16114,
	"./Flag/united kingdom.png": 10793,
	"./Flag/us.png": 4523,
	"./HelpButtons/Book.png": 68660,
	"./HelpButtons/FAQ.png": 36203,
	"./HelpButtons/I_icon.png": 58612,
	"./HelpButtons/Report.png": 71533,
	"./HelpButtons/Request.png": 18088,
	"./HelpButtons/error.png": 49193,
	"./HelpButtons/success.png": 77794,
	"./Heygen/AIoptionsecond.png": 26144,
	"./Heygen/EEP1.png": 72682,
	"./Heygen/EEP2.png": 3265,
	"./Heygen/EEP21.png": 29228,
	"./Heygen/EEP3.png": 82136,
	"./Heygen/EEP4.png": 31127,
	"./Heygen/EEP5.png": 85550,
	"./Heygen/EEP6.png": 55909,
	"./Heygen/EEP7.png": 73020,
	"./Heygen/EEP8.png": 82507,
	"./Heygen/EEP9.png": 61378,
	"./Heygen/GirlImageforHeygenAvatarPreview.png": 2494,
	"./Heygen/Heygen Logo.png": 8480,
	"./Heygen/Heygen_Avatar_Creation.png": 24717,
	"./Heygen/Heygen_Theme.png": 78931,
	"./Heygen/InstaPost.png": 90594,
	"./Heygen/InstaReel.png": 42300,
	"./Heygen/IntroImage.png": 57640,
	"./Heygen/Landscape.png": 5134,
	"./Heygen/Squre.png": 247,
	"./Heygen/badpicexamplefive.png": 68810,
	"./Heygen/badpicexamplefour.png": 40294,
	"./Heygen/badpicexampleone.png": 42192,
	"./Heygen/badpicexamplesec.png": 46375,
	"./Heygen/badpicexamplethir.png": 77155,
	"./Heygen/goodpicexamplefive.png": 73980,
	"./Heygen/goodpicexamplefour.png": 62348,
	"./Heygen/goodpicexampleone.png": 86502,
	"./Heygen/goodpicexamplerhi.png": 83085,
	"./Heygen/goodpicexamplesec.png": 31197,
	"./Heygen/img1.jpg": 40435,
	"./Icon/female.png": 33788,
	"./Icon/male.png": 4583,
	"./ImageForVideoPreview.png": 86123,
	"./LLM_Modal_Logo/chatgpt-logo-png.png": 97821,
	"./LLM_Modal_Logo/clude_Logo.png": 18195,
	"./LadingPage_ActionImage_Mobile.png": 65015,
	"./LandingPage_Items/1_image.png": 68625,
	"./LandingPage_Items/2_Video.png": 90828,
	"./LandingPage_Items/3_audio.png": 59298,
	"./LandingPage_Items/4_WebTrack.png": 84840,
	"./LandingPage_Items/5_Presentation.png": 82168,
	"./LandingPage_Items/6_Blog.png": 17013,
	"./LandingPage_Items/Actionable_Image.png": 35232,
	"./LandingPage_Items/CallingAgent/CallModalX.png": 42389,
	"./LandingPage_Items/CallingAgent/CallVic.png": 67600,
	"./LandingPage_Items/CallingAgent/CallingAgentHeroImage.png": 28924,
	"./LandingPage_Items/CallingAgent/CallingAgentHeroImageBelow991.png": 80298,
	"./LandingPage_Items/CallingAgent/CallingAgentHeroImageBelow991New.png": 55242,
	"./LandingPage_Items/CallingAgent/CallingAgentHeroImageNew.png": 6328,
	"./LandingPage_Items/CallingAgent/Ellipse Gradient.png": 92554,
	"./LandingPage_Items/CallingAgent/ModalX.png": 57937,
	"./LandingPage_Items/CallingAgent/ModalX_X_Icon.png": 47246,
	"./LandingPage_Items/CallingAgent/QR Code New.png": 40280,
	"./LandingPage_Items/CallingAgent/QR Code.png": 84782,
	"./LandingPage_Items/CallingAgent/User1.png": 26364,
	"./LandingPage_Items/CallingAgent/User2.png": 15095,
	"./LandingPage_Items/CallingAgent/User3.png": 25102,
	"./LandingPage_Items/CallingAgent/User4.png": 8193,
	"./LandingPage_Items/CallingAgent/User5.png": 35480,
	"./LandingPage_Items/CallingAgent/Vic.png": 25708,
	"./LandingPage_Items/CallingAgent/Whatsapp.png": 85378,
	"./LandingPage_Items/CallingAgent/WhatsappVic.png": 52066,
	"./LandingPage_Items/CallingAgent/image1.png": 63380,
	"./LandingPage_Items/CallingAgent/image2.png": 82287,
	"./LandingPage_Items/CallingAgent/image3.png": 43270,
	"./LandingPage_Items/CallingAgent/image4.png": 36345,
	"./LandingPage_Items/CallingAgent/image5.png": 39440,
	"./LandingPage_Items/CaseStudies/Logo.png": 23043,
	"./LandingPage_Items/CaseStudies/UpArrow_Icon.png": 58440,
	"./LandingPage_Items/CaseStudies/casestudy01.png": 22894,
	"./LandingPage_Items/CaseStudies/casestudy02.png": 93253,
	"./LandingPage_Items/CaseStudies/casestudy03.png": 10364,
	"./LandingPage_Items/How It Works/Checked.png": 69969,
	"./LandingPage_Items/How It Works/Search_User.png": 67932,
	"./LandingPage_Items/How It Works/User_Edit.png": 62378,
	"./LandingPage_Items/How It Works/how_works_image_below_990.png": 86992,
	"./LandingPage_Items/How It Works/video output Image for How it works.png": 61243,
	"./LandingPage_Items/ImageGallery/imageGallery01.png": 31026,
	"./LandingPage_Items/ImageGallery/imageGallery02.png": 21737,
	"./LandingPage_Items/ImageGallery/imageGallery03.png": 66912,
	"./LandingPage_Items/ImageGallery/imageGallery04.png": 18239,
	"./LandingPage_Items/ImageGallery/imageGallery05.png": 21910,
	"./LandingPage_Items/ImageGallery/imageGallery06.png": 3533,
	"./LandingPage_Items/ImageGallery/imageGallery07.png": 63588,
	"./LandingPage_Items/ImageGallery/imageGallery08.png": 21251,
	"./LandingPage_Items/ImageGallery/imageGallery09.png": 3674,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Audio/audio1.webp": 56532,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Audio/audio2.webp": 15793,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Audio/audio3.webp": 58518,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Audio/audio4.webp": 83675,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Audio/audio5.webp": 7224,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Blog/blog1.webp": 55478,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Blog/blog2.webp": 97303,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Blog/blog3.webp": 12596,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Blog/blog4.webp": 72805,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Blog/blog5.webp": 58778,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/IconForSmallScreen.png": 47141,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Image/image1.webp": 92220,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Image/image2.webp": 35257,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Image/image3.webp": 93822,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Image/image4.webp": 86883,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Image/image5.webp": 40128,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/ImageHover.png": 54487,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/ModalXBlack.png": 80772,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Presentation/presentation1.webp": 9458,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Presentation/presentation2.webp": 43731,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Presentation/presentation3.webp": 17968,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Presentation/presentation4.webp": 69289,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Presentation/presentation5.webp": 30190,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report1.png": 33852,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report1.webp": 99218,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report2.png": 57783,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report2.webp": 33491,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report3.png": 58286,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Report/report3.webp": 7728,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation1.png": 22546,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation1.webp": 96720,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation2.png": 87689,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation2.webp": 39549,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation3.png": 16512,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation3.webp": 88210,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation4.png": 75167,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation4.webp": 68239,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation5.png": 13430,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/Translation/Translation5.webp": 27372,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/blog.png": 48880,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/image.png": 42349,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/leftLines.png": 43802,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/linesWithLogo.png": 41306,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/mov_logo.png": 76828,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/mp3_logo.png": 80372,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/pdf_icon.png": 3650,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/pdf_logo.png": 928,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/powerpoint_logo.png": 72829,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/presentation.png": 76952,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/rightLines.png": 55391,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/speech.png": 75302,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/translation.png": 25679,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video.png": 31215,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video1.png": 98850,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video1.webp": 17664,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video2.png": 47033,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video2.webp": 12333,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video3.png": 66480,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video3.webp": 87394,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video4.png": 92975,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video4.webp": 83295,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video5.png": 53958,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video/video5.webp": 55356,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/video_logo.png": 33657,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch1.png": 32622,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch1.webp": 79828,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch2.png": 35045,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch2.webp": 46545,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch3.png": 17532,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/websearch/websearch3.webp": 46518,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/word_logo.png": 10568,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/xlsx_logo.png": 72963,
	"./LandingPage_Items/LandingPageCapabilitiesIcon/youtube_logo.png": 39855,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio1.png": 82108,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio1.webp": 23644,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio2.png": 6039,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio2.webp": 83033,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio3.png": 6542,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio3.webp": 41598,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio4.png": 5025,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio4.webp": 18307,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio5.png": 83896,
	"./LandingPage_Items/LandingPageFeatureIcon/Audio/audio5.webp": 87904,
	"./LandingPage_Items/LandingPageFeatureIcon/Blog/blog1.webp": 54398,
	"./LandingPage_Items/LandingPageFeatureIcon/Blog/blog2.webp": 43039,
	"./LandingPage_Items/LandingPageFeatureIcon/Blog/blog3.webp": 52796,
	"./LandingPage_Items/LandingPageFeatureIcon/Blog/blog4.webp": 95373,
	"./LandingPage_Items/LandingPageFeatureIcon/Blog/blog5.webp": 39810,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image1.png": 42060,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image1.webp": 44740,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image2.png": 10535,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image2.webp": 79265,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image3.png": 39198,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image3.webp": 9510,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image4.png": 75313,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image4.webp": 88235,
	"./LandingPage_Items/LandingPageFeatureIcon/Image/image5.webp": 53992,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation1.png": 73226,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation1.webp": 49210,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation2.png": 22209,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation2.webp": 9659,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation3.png": 53944,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation3.webp": 24312,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation4.webp": 81137,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation5.png": 86094,
	"./LandingPage_Items/LandingPageFeatureIcon/Presentation/presentation5.webp": 62262,
	"./LandingPage_Items/LandingPageFeatureIcon/WebTrack/webtrack1.png": 13912,
	"./LandingPage_Items/LandingPageFeatureIcon/WebTrack/webtrack1.webp": 9656,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video1.png": 84120,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video1.webp": 42440,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video2.png": 46227,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video2.webp": 81845,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video3.png": 91018,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video3.webp": 14314,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video4.png": 57893,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video4.webp": 63591,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video5.png": 75004,
	"./LandingPage_Items/LandingPageFeatureIcon/video/video5.webp": 65764,
	"./LandingPage_Items/LandingPageHowItWorks/newproject1.png": 31688,
	"./LandingPage_Items/LandingPageHowItWorks/newproject2.png": 93667,
	"./LandingPage_Items/LandingPageHowItWorks/newproject3.png": 3834,
	"./LandingPage_Items/Landingpage_Modalx_FlowDiagram.png": 75672,
	"./LandingPage_Items/Landingpage_Modalx_FlowDiagram_below_990.png": 96989,
	"./LandingPage_Items/Logo_1.png": 70429,
	"./LandingPage_Items/Logo_2.png": 89222,
	"./LandingPage_Items/Logo_3.png": 28239,
	"./LandingPage_Items/Logo_4.png": 32368,
	"./LandingPage_Items/Logo_5.png": 38617,
	"./LandingPage_Items/Logo_6.png": 82530,
	"./LandingPage_Items/Logo_7.png": 3659,
	"./LandingPage_Items/ModalxInAction_Icons/Image1.png": 6034,
	"./LandingPage_Items/ModalxInAction_Icons/Image2.png": 71177,
	"./LandingPage_Items/ModalxInAction_Icons/Image3.png": 16352,
	"./LandingPage_Items/ModalxInAction_Icons/Image4.png": 75007,
	"./LandingPage_Items/ModalxInAction_Icons/Image5.png": 96918,
	"./LandingPage_Items/ModalxInAction_Icons/Image6.png": 87597,
	"./LandingPage_Items/ModalxInAction_Icons/Image7.png": 61444,
	"./LandingPage_Items/ModalxInAction_Icons/Image8.png": 5315,
	"./LandingPage_Items/ModalxInAction_Icons/Image_1.png": 36511,
	"./LandingPage_Items/ModalxInAction_Icons/Image_2.png": 99652,
	"./LandingPage_Items/ModalxInAction_Icons/Image_3.png": 53549,
	"./LandingPage_Items/ModalxInAction_Icons/Image_4.png": 48690,
	"./LandingPage_Items/ModalxInAction_Icons/Image_5.png": 63515,
	"./LandingPage_Items/ModalxInAction_Icons/Image_6.png": 1536,
	"./LandingPage_Items/ModalxInAction_Icons/Image_7.png": 79657,
	"./LandingPage_Items/ModalxInAction_Icons/Image_8.png": 33790,
	"./LandingPage_Items/Personalized_Img_1.png": 24414,
	"./LandingPage_Items/Personalized_Img_1_990.png": 48653,
	"./LandingPage_Items/Personalized_Img_2.png": 10165,
	"./LandingPage_Items/Personalized_Img_2_990.png": 17538,
	"./LandingPage_Items/Personalized_Img_3.png": 74252,
	"./LandingPage_Items/Personalized_Img_3_990.png": 17247,
	"./LandingPage_Items/Testimonials/Avatar.png": 55610,
	"./LandingPage_Items/Testimonials/linkedin.png": 79651,
	"./LandingPage_Items/VideoGallery/video (2).png": 44554,
	"./LandingPage_Items/VideoGallery/video (3).png": 59985,
	"./LandingPage_Items/VideoGallery/video (4).png": 81984,
	"./LandingPage_Items/VideoGallery/video (5).png": 2343,
	"./LandingPage_Items/VideoGallery/video (6).png": 86038,
	"./LandingPage_Items/VideoGallery/video (7).png": 51549,
	"./LandingPage_Items/VideoGallery/video (8).png": 36396,
	"./LandingPage_Items/VideoGallery/video (9).png": 14451,
	"./LandingPage_Items/VideoGallery/video.png": 39949,
	"./LandingPage_Items/VideoGallery/videoGallery01.png": 49982,
	"./LandingPage_Items/VideoGallery/videoGallery02.png": 35733,
	"./LandingPage_Items/VideoGallery/videoGallery03.png": 52844,
	"./LandingPage_Items/VideoGallery/videoGallery04.png": 83011,
	"./LandingPage_Items/VideoGallery/videoGallery05.png": 61434,
	"./LandingPage_Items/VideoGallery/videoGallery06.png": 86097,
	"./LandingPage_Items/VideoGallery/videoGallery07.png": 46152,
	"./LandingPage_Items/VideoGallery/videoGallery08.png": 52703,
	"./LandingPage_Items/VideoGallery/videoGallery09.png": 74614,
	"./LandingPage_Items/founder/image1.png": 42420,
	"./LandingPage_Items/founder/image2.png": 63887,
	"./LandingPage_Items/founder/image3.png": 82342,
	"./LandingPage_Items/founder/image4.png": 84761,
	"./LandingPage_Items/modalx_Round_Icon_dm.png": 44094,
	"./LandingPage_Items/useCases/useCase01.png": 92401,
	"./LandingPage_Items/useCases/useCase02.png": 71290,
	"./LandingPage_Items/useCases/useCase03.png": 35395,
	"./LandingPage_Items/useCases/useCase04.png": 59148,
	"./LandingPage_Items/videoThumnail/VideoThumbnail.png": 34217,
	"./LandingPage_Logos.png": 7043,
	"./Landingpage_HeroImage.png": 81472,
	"./Link_Icon.png": 61538,
	"./LinkedInIconForUserInfo.png": 22257,
	"./LoadingImages/ModalX_logo.png": 28036,
	"./LoadingImages/ModalX_logo1.png": 73959,
	"./LoadingImages/ModalX_logo10.png": 14215,
	"./LoadingImages/ModalX_logo2.png": 23276,
	"./LoadingImages/ModalX_logo3.png": 34901,
	"./LoadingImages/ModalX_logo4.png": 66490,
	"./LoadingImages/ModalX_logo5.png": 72675,
	"./LoadingImages/ModalX_logo6.png": 94344,
	"./LoadingImages/ModalX_logo7.png": 42737,
	"./LoadingImages/ModalX_logo8.png": 3958,
	"./LoadingImages/ModalX_logo9.png": 57759,
	"./Marketing_Page/Post1.png": 12256,
	"./Marketing_Page/Post2.png": 90587,
	"./Marketing_Page/Post3.png": 76370,
	"./Marketing_Page/Post4.png": 48877,
	"./Marketing_Page/Post5.png": 8932,
	"./Marketing_Page/Post6.png": 63583,
	"./Marketing_Page/boyImage.png": 55434,
	"./Marketing_Page/boyImageSmallScreen.png": 53537,
	"./Marketing_Page/ladyImage.png": 78812,
	"./Marketing_Page/ladyImageSmallScreen.png": 46043,
	"./ModalX_-_Black_Gradient-removebg.png": 88468,
	"./ModalX_-orange_Icon.png": 23935,
	"./ModalX_Globe.gif": 42176,
	"./ModalX_Video_Preview.mp4": 14537,
	"./ModalX_Video_Preview2.mp4": 9191,
	"./ModalX_Video_Preview_old _video.mp4": 43323,
	"./ModalX_WorkFlowDiagram(900).png": 76794,
	"./ModalX_WorkFlowDiagram.png": 94130,
	"./ModalX_landingPage_Video.mp4": 2457,
	"./Modal_Logo_For_Navbar.png": 4194,
	"./Modal_X_-_B_W-removebg.png": 70845,
	"./Modalx_Dark_Logo.png": 3850,
	"./OfferImages/FlowerImage.png": 47855,
	"./OfferImages/HaldTree.png": 88846,
	"./OfferImages/HalfFlower.png": 52949,
	"./OfferImages/TreeImage.png": 86428,
	"./OfferImages/boxImage.png": 59945,
	"./OfferImages/copy.png": 23956,
	"./PersonalAvatarCheckIcon.png": 76704,
	"./PersonalAvatarCreationSampleVideo.mp4": 18486,
	"./PersonalAvatarIcon/Personal Avatar.png": 63750,
	"./PresentationGallery/01.png": 61760,
	"./PresentationGallery/02.png": 40091,
	"./PresentationGallery/03.png": 25266,
	"./PresentationGallery/04.png": 30125,
	"./PresentationGallery/05.png": 76228,
	"./PresentationGallery/06.png": 13087,
	"./PresentationGallery/07.png": 16150,
	"./PresentationGallery/08.png": 93457,
	"./PresentationGallery/09.png": 83240,
	"./PresentationGallery/ModalxLogo.png": 4821,
	"./PresentationGallery/blog1.png": 61044,
	"./PricePlanIcon/BasicIcon.png": 49731,
	"./PricePlanIcon/ModalXLogoForInsideWorkspace.png": 73104,
	"./PricePlanIcon/PremiumIcon.png": 95498,
	"./ReportIcon.png": 74625,
	"./Safety/Image_1.png": 46328,
	"./SampleCSVFIle/Sample_CSV_file.csv": 50373,
	"./SendIcon": 60311,
	"./SendIcon.jsx": 60311,
	"./SuggestedForMobileView/Music.png": 60051,
	"./SuggestedForMobileView/Statistics.png": 40849,
	"./SuggestedForMobileView/image.png": 74497,
	"./SuggestedForMobileView/video.png": 14491,
	"./SuggestionIcon/BlogIconForblog.png": 71846,
	"./SuggestionIcon/MusicIconFormusic.png": 97766,
	"./SuggestionIcon/PictureIconForpicture.png": 62710,
	"./SuggestionIcon/audioPicture.png": 35832,
	"./SuggestionIcon/blogPicture.png": 98432,
	"./SuggestionIcon/imagePicture.png": 11135,
	"./SuggestionIcon/presentationIconForpresentation.png": 28302,
	"./SuggestionIcon/presentationPicture.png": 29976,
	"./SuggestionIcon/searchIconForsearch.png": 37702,
	"./SuggestionIcon/searchPicture.png": 65384,
	"./SuggestionIcon/videoIconForvideo.png": 55214,
	"./SuggestionIcon/videoPicture.png": 59765,
	"./UpdatedModalxLandingPageVideo.mp4": 45688,
	"./Upload_Icon.png": 22355,
	"./VeoVideo/LandscapeVideoRatio.png": 20887,
	"./VeoVideo/mobile.png": 16754,
	"./VideoSettings_DIDThumbnail.png": 40680,
	"./VideoSettings_VideoGenThumbnail.png": 15014,
	"./VideoTutorial/CreateAudioTutorial.mp4": 44935,
	"./VideoTutorial/CreateImageTutorial.mp4": 14490,
	"./VideoTutorial/CreateVideoTutorial.mp4": 66448,
	"./Website Tracking/DefaultIconFor_Websites.png": 30805,
	"./canadaFlag.png": 58416,
	"./cd.png": 5273,
	"./companyLogo.webp": 93750,
	"./completeIcon.png": 22658,
	"./error.png": 61644,
	"./errorIconWhileGenerating.png": 33924,
	"./greencheckIcon.png": 4368,
	"./homeSlide1.webp": 20885,
	"./homeSlide2.webp": 97832,
	"./homeSlide3.webp": 5771,
	"./homeSlide4.webp": 60294,
	"./homeSlide5.webp": 46401,
	"./homeSlide6.webp": 4804,
	"./homeSlide7.webp": 18983,
	"./im.png": 22782,
	"./image1.webp": 45506,
	"./image2.webp": 53155,
	"./image3.webp": 22752,
	"./image4.webp": 17881,
	"./info.png": 16768,
	"./info_icon.png": 69918,
	"./landingPageActionImage.png": 86889,
	"./mail.png": 37605,
	"./mdi_magic.png": 52446,
	"./modalXIconWIthErrorIcon.png": 57437,
	"./modalX_Dark.svg": 65482,
	"./modalX_Light.svg": 68178,
	"./modalX_robot_icon_black.png": 20218,
	"./modalX_robot_icon_white.png": 75052,
	"./modalX_transparent_orange_icon.png": 77593,
	"./modalX_twin.svg": 93316,
	"./modalxIcon.png": 71762,
	"./modalx_logo_for_landingpage_dm.png": 82310,
	"./openrouter-icon.png": 87989,
	"./plusIcon_for_new_project.png": 56174,
	"./ppt_template_1.png": 18533,
	"./ppt_template_2.png": 46734,
	"./ppt_template_3.png": 89751,
	"./ppt_template_4.png": 98232,
	"./ppt_template_5.png": 82849,
	"./ppt_template_6.png": 33866,
	"./ppt_template_image1.png": 89302,
	"./ppt_template_image2.png": 3277,
	"./ppt_template_image3.png": 49380,
	"./ppt_template_image4.png": 13243,
	"./progressIndicator.png": 97686,
	"./shareIcon.png": 69204,
	"./shareModalForSocialMedia/ayush.png": 48451,
	"./shareModalForSocialMedia/completeImage.png": 98517,
	"./shareModalForSocialMedia/facebookPost.png": 90055,
	"./shareModalForSocialMedia/facebookStories.png": 17974,
	"./shareModalForSocialMedia/instragram.png": 78587,
	"./shareModalForSocialMedia/jupiter.png": 44109,
	"./shareModalForSocialMedia/linkedin.png": 56983,
	"./shareModalForSocialMedia/linkedinPage.png": 78550,
	"./shareModalForSocialMedia/linkedinProfile.png": 56216,
	"./shareModalForSocialMedia/postImage1.png": 34287,
	"./shareModalForSocialMedia/printerest.png": 95109,
	"./shareModalForSocialMedia/x.png": 20565,
	"./shareModalForSocialMedia/youTube.png": 49498,
	"./sidebarIcon/Sidebarcompanylogo.png": 65062,
	"./sidebarIcon/hidesidebarlogo.png": 55793,
	"./sidebarIcon/smallsidebarcompanylogo.png": 2649,
	"./signup/Frame 118.png": 10804,
	"./signup/Frame 142.png": 22745,
	"./signup/Frame118MobileView.png": 62115,
	"./signup/Frame142MobileView.png": 84362,
	"./signup/Frame174MobileView.png": 56297,
	"./signup/Group 174.png": 91508,
	"./signup/error.png": 92531,
	"./signup/loginPageLogo.png": 28870,
	"./signup/mail.png": 1532,
	"./signup/ppt1.png": 11380,
	"./signup/ppt2.png": 2223,
	"./signup/ppt3.png": 63206,
	"./signup/success.png": 45232,
	"./transparent-google-logo-google-logo-with-multicolored-g-and-1710875781697.png": 47991,
	"./updatedModalxLogo.png": 79923,
	"./upgradeLogo.png": 32535,
	"./userIcon.png": 45234,
	"./web-plus.png": 48147,
	"./web_cachedIcon.png": 39264,
	"./—Pngtree—facebook social media icon facebook_3654772.png": 30804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;